import React from 'react';
import {Paragraph, Title, Image} from './../../Basics';

const Particle17 = () => (<div>

  <Title>Diese Roboteranzüge gibt es bereits</Title>
  <Paragraph>
    Noch gibt es sehr wenige Gebehinderte, die mit Hilfe von Exoskeletten laufen. Hauptgründe: Preis und Gewicht. Viele der Geräte kosten zwischen 70 000 und 100 000 Franken. Ausserdem sind sie meist klobig und schwer. Beispielsweise wiegt das noch nicht marktreife Modell des Schweizer Teams Varileg, das auch am Cybathlon am Start war, 35 Kilogramm. Doch immer leichtere und günstigere Modelle kommen auf den Markt oder sind derzeit in der Entwicklung:
  </Paragraph>

  <Image
    source={require('./17_Bild_1_ReWalk.jpg')}
    title='Abbildung Exoskelett Rewalk'
    caption='Das Exoskelett der israelischen Firma Rewalk – es war ebenfalls am
      Cybathlon zu sehen – ist mit 20 Kilogramm deutlich leichter. Es wird in
      Italien und den USA, wo die Versicherungen die Kosten übernehmen,
      bereits von einzelnen Betroffenen getragen. Rewalk ist die
      Weiterentwicklung einer militärischen Technologie.'
  />

  <Image
    source={require('./17_Bild_2_SuitX.jpg')}
    title='Abbildung Exoskelett Rewalk'
    caption='Ein Durchbruch für Paraplegiker scheint Anfang 2016 der Firma
      SuitX gelungen zu sein, die aus der kalifornischen Universität Berkeley
      hervorging. Ihr Gerät «Phoenix» wiegt lediglich 12 Kilogramm und ist mit
      einem Preis von 40 000 Franken nur etwa halb so teuer wie herkömmliche Modelle.'
  />

  <Image
    source={require('./17_Bild_3_infografik-xosoft.jpg')}
    title='Abbildung Exoskelett Rewalk'
    caption='Ein besonderes Modell entwickelt derzeit die Zürcher Hochschule für
      Angewandte Wissenschaften ZHAW im Rahmen des EU-Projekts XoSoft. Das
      künftige Produkt – ein Soft-Exoskelett – soll aussehen wie eine Art Leggins
      und man soll es unter die Kleidung ziehen können. Weil es aber nicht das
      volle Körpergewicht stützen kann, ist es eher für Menschen mit Muskelschwäche
      geeignet denn für Patienten mit vollständiger Beinlähmung.'
  />



</div>);

export default Particle17;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle17/Particle17.js
 **/